/* nrt-cart-v1 */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var drawer = document.querySelector('.nrt-drawer');
    if (!drawer) return;

    function openD() { drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function closeD() { drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

    /* Open from any link to /cart (intercept) */
    document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        refresh().then(openD);
      });
    });

    /* Close handlers */
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    var scrim = drawer.querySelector('.nrt-drawer__scrim');
    if (closeBtn) closeBtn.addEventListener('click', closeD);
    if (scrim) scrim.addEventListener('click', closeD);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeD();
    });

    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    function render(cart) {
      var body = drawer.querySelector('.nrt-drawer__body');
      var foot = drawer.querySelector('.nrt-drawer__foot');
      if (!body || !foot) return;
      if (!cart.items || cart.items.length === 0) {
        body.innerHTML = '<div class="nrt-drawer__empty"><h3>Your bag is empty.</h3><p>Start with the editor\'s edit, or pick a room.</p><a href="/" class="nrt-drawer__cta">Browse the edit →</a></div>';
        foot.style.display = 'none';
        return;
      }
      foot.style.display = '';
      var html = '<div class="nrt-drawer__items">';
      cart.items.forEach(function (it) {
        html += '<div class="nrt-drawer__item" data-key="' + it.key + '">' +
          '<img src="' + (it.image ? it.image : '') + '" alt="">' +
          '<div>' +
            '<div class="nrt-drawer__item-brand">' + (it.vendor || '') + '</div>' +
            '<div class="nrt-drawer__item-title">' + it.product_title + '</div>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="nrt-drawer__item-meta">' + it.variant_title + '</div>' : '') +
            '<div class="nrt-drawer__item-row">' +
              '<div class="nrt-drawer__qty">' +
                '<button type="button" data-qty-dec aria-label="Decrease">−</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-qty-inc aria-label="Increase">+</button>' +
              '</div>' +
              '<button type="button" data-remove class="nrt-drawer__remove">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="nrt-drawer__item-price">' + money(it.final_line_price) + '</div>' +
        '</div>';
      });
      html += '</div>';
      body.innerHTML = html;

      var threshold = 6000; /* $60 free shipping */
      var subtotal = cart.items_subtotal_price || cart.total_price;
      var pct = Math.min(100, Math.round(subtotal / threshold * 100));
      var remaining = Math.max(0, threshold - subtotal);
      var progressHtml = '';
      if (subtotal < threshold) {
        progressHtml = '<div class="nrt-drawer__progress"><div class="nrt-drawer__progress-row"><span>Add <b>' + money(remaining) + '</b> for free shipping</span><span>' + pct + '%</span></div><div class="nrt-drawer__progress-bar"><div class="nrt-drawer__progress-fill" style="width:' + pct + '%"></div></div></div>';
      } else {
        progressHtml = '<div class="nrt-drawer__progress" style="background:var(--accent-tint);color:var(--accent-deep);"><b>Free shipping unlocked.</b></div>';
      }

      foot.innerHTML = progressHtml +
        '<div class="nrt-drawer__totals">' +
          '<div class="nrt-drawer__totals-row"><span>Subtotal</span><span>' + money(subtotal) + '</span></div>' +
          '<div class="nrt-drawer__totals-row"><span>Shipping</span><span>' + (subtotal >= threshold ? 'Free' : '$8') + '</span></div>' +
          '<div class="nrt-drawer__totals-final"><span class="label">Total</span><span class="val">' + money(subtotal + (subtotal >= threshold ? 0 : 800)) + '</span></div>' +
        '</div>' +
        '<a href="/checkout" class="nrt-drawer__cta">Checkout — ' + money(subtotal + (subtotal >= threshold ? 0 : 800)) + '</a>' +
        '<a href="#" class="nrt-drawer__continue" data-drawer-close-link>Continue shopping</a>' +
        '<div class="nrt-drawer__trust">' +
          '<div class="nrt-drawer__trust-row"><span>•</span> Discreet billing — charged as &lsquo;NRT Goods&rsquo;</div>' +
          '<div class="nrt-drawer__trust-row"><span>•</span> Plain box, no branding visible</div>' +
          '<div class="nrt-drawer__trust-row"><span>•</span> All sales final — for hygiene &amp; privacy</div>' +
        '</div>';

      /* Wire qty + remove */
      drawer.querySelectorAll('.nrt-drawer__item').forEach(function (it) {
        var key = it.getAttribute('data-key');
        var inc = it.querySelector('[data-qty-inc]');
        var dec = it.querySelector('[data-qty-dec]');
        var rm  = it.querySelector('[data-remove]');
        if (inc) inc.addEventListener('click', function () { changeItem(key, 1); });
        if (dec) dec.addEventListener('click', function () { changeItem(key, -1); });
        if (rm) rm.addEventListener('click', function () { setItem(key, 0); });
      });
      var contLink = drawer.querySelector('[data-drawer-close-link]');
      if (contLink) contLink.addEventListener('click', function (e) { e.preventDefault(); closeD(); });
    }

    function refresh() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); updateCount(cart.item_count); return cart; });
    }

    function changeItem(key, delta) {
      var current = drawer.querySelector('.nrt-drawer__item[data-key="' + key + '"] .nrt-drawer__qty span');
      var qty = current ? (parseInt(current.textContent, 10) || 1) : 1;
      var newQty = Math.max(0, qty + delta);
      setItem(key, newQty);
    }

    function setItem(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () { refresh(); });
    }

    function updateCount(n) {
      document.querySelectorAll('.nrt-bagcount, .nrt-mheader__bagcount').forEach(function (b) {
        if (n > 0) { b.textContent = n; b.style.display = ''; }
        else { b.style.display = 'none'; }
      });
    }

    /* Public API for PDP add-to-cart */
    window.nrtCartDrawer = { open: openD, close: closeD, refresh: refresh };

    /* Initial population */
    refresh();
  });
})();

/* ── Age gate ── */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var gate = document.querySelector('.nrt-agegate');
    if (!gate) return;
    var key = 'nrt-age-confirmed';
    function isConfirmed() {
      try { if (localStorage.getItem(key) === '1') return true; } catch (e) {}
      return document.cookie.split(';').some(function (c) { return c.trim().indexOf(key + '=1') === 0; });
    }
    if (isConfirmed()) return;
    gate.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var yes = gate.querySelector('[data-age-yes]');
    var no  = gate.querySelector('[data-age-no]');
    if (yes) yes.addEventListener('click', function () {
      try { localStorage.setItem(key, '1'); } catch (e) {}
      document.cookie = key + '=1;path=/;max-age=' + (60 * 60 * 24 * 365) + ';samesite=lax';
      gate.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
    if (no) no.addEventListener('click', function () {
      window.location.href = 'https://www.google.com';
    });
  });
})();
